module.exports = __webpack_public_path__ + "static/media/1.30d3d37b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/1041/1.jpg
// module id = 420
// module chunks = 0